var _path, _path2, _path3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionUnlimitedDownloadsColoredDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5Z",
    fill: "#5714CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14C5.55228 14 6 14.4477 6 15V18H18V15C18 14.4477 18.4477 14 19 14C19.5523 14 20 14.4477 20 15V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V15C4 14.4477 4.44772 14 5 14Z",
    fill: "#FFC30D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4C9.55228 4 10 4.44772 10 5V11.5858L11.2929 10.2929C11.6834 9.90237 12.3166 9.90237 12.7071 10.2929C13.0976 10.6834 13.0976 11.3166 12.7071 11.7071L9.70711 14.7071C9.31658 15.0976 8.68342 15.0976 8.29289 14.7071L5.29289 11.7071C4.90237 11.3166 4.90237 10.6834 5.29289 10.2929C5.68342 9.90237 6.31658 9.90237 6.70711 10.2929L8 11.5858V5C8 4.44772 8.44772 4 9 4Z",
    fill: "#FFC30D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5858V11.5858L10.5 11.0858L10 10.5858Z",
    fill: "#FFC30D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10.5858L11.2929 10.2929C11.6834 9.90237 12.3166 9.90237 12.7071 10.2929C13.0976 10.6834 13.0976 11.3166 12.7071 11.7071L10.5 13.9142L11.2929 14.7071C11.6834 15.0976 12.3166 15.0976 12.7071 14.7071L15.7071 11.7071C16.0976 11.3166 16.0976 10.6834 15.7071 10.2929C15.3166 9.90237 14.6834 9.90237 14.2929 10.2929L13 11.5858V5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V10.5858Z",
    fill: "#FFC30D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 10.5858L13.5 11.0858L13 11.5858V10.5858Z",
    fill: "#FFC30D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5858L14.2929 10.2929C14.6834 9.90237 15.3166 9.90237 15.7071 10.2929C15.9022 10.488 15.9998 10.7436 16 10.9993V5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5V10.5858Z",
    fill: "#FFC30D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.0007C15.9998 11.2564 15.9022 11.512 15.7071 11.7071L13.5 13.9142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071L18.7071 11.7071C19.0976 11.3166 19.0976 10.6834 18.7071 10.2929C18.3166 9.90237 17.6834 9.90237 17.2929 10.2929L16 11.5858V11.0007Z",
    fill: "#FFC30D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.4142L12.7071 11.7071C13.0976 11.3166 13.0976 10.6834 12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929C10.9024 10.6834 10.9024 11.3166 11.2929 11.7071L12 12.4142Z",
    fill: "#FFC30D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionUnlimitedDownloadsColoredDay);
export default __webpack_public_path__ + "static/media/ic_action_unlimited_downloads_colored_day.644fd271d7b7611d82b6a2767d79c490.svg";
export { ForwardRef as ReactComponent };